import React from "react";
import { useQueryClient } from "@tanstack/react-query";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withQueryClient = (Component: React.ComponentType) => (props: any) => {
  const queryClient = useQueryClient();
  return <Component {...props} queryClient={queryClient} />;
};

export default withQueryClient;
